import script from "./WompiForm.vue?vue&type=script&setup=true&lang=js"
export * from "./WompiForm.vue?vue&type=script&setup=true&lang=js"

import "./WompiForm.vue?vue&type=style&index=0&id=6ba7a44a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba7a44a"]])

export default __exports__